/* tslint:disable */
/* eslint-disable */
/**
 * ELOfleet API Documentation
 * Backend of the ELOfleet fleet management system
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
    type ErrorResponse,
    ErrorResponseFromJSON,
    ErrorResponseToJSON,
} from '../models/ErrorResponse';
import {
    type PageInfo,
    PageInfoFromJSON,
    PageInfoToJSON,
} from '../models/PageInfo';
import {
    type ShockProfile,
    ShockProfileFromJSON,
    ShockProfileToJSON,
} from '../models/ShockProfile';
import {
    type ShockProfileCreate,
    ShockProfileCreateFromJSON,
    ShockProfileCreateToJSON,
} from '../models/ShockProfileCreate';
import {
    type ShockProfileSortKey,
    ShockProfileSortKeyFromJSON,
    ShockProfileSortKeyToJSON,
} from '../models/ShockProfileSortKey';
import {
    type ShockProfileUpdate,
    ShockProfileUpdateFromJSON,
    ShockProfileUpdateToJSON,
} from '../models/ShockProfileUpdate';
import {
    type SortDirection,
    SortDirectionFromJSON,
    SortDirectionToJSON,
} from '../models/SortDirection';

export interface ShockProfilesCreateShockProfileRequest {
    shockProfileCreate: ShockProfileCreate;
}

export interface ShockProfilesDeleteShockProfileRequest {
    shockProfileId: string;
}

export interface ShockProfilesListShockProfilesRequest {
    pageSize: number;
    page?: number | null;
    sortDirection?: SortDirection;
    sortKey?: ShockProfileSortKey;
}

export interface ShockProfilesListShockProfilesMetadataRequest {
    pageSize: number;
}

export interface ShockProfilesReadShockProfileRequest {
    shockProfileId: string;
}

export interface ShockProfilesUpdateShockProfileRequest {
    shockProfileId: string;
    shockProfileUpdate: ShockProfileUpdate;
}

export interface ShockProfilesValidateCreateShockProfileRequest {
    shockProfileCreate: ShockProfileCreate;
}

export interface ShockProfilesValidateUpdateShockProfileRequest {
    shockProfileId: string;
    shockProfileUpdate: ShockProfileUpdate;
}

/**
 * ShockProfilesApi - interface
 * 
 * @export
 * @interface ShockProfilesApiInterface
 */
export interface ShockProfilesApiInterface {
    /**
     * Creates request options for shockProfilesCreateShockProfile without sending the request
     * @param {ShockProfileCreate} shockProfileCreate 
     * @throws {RequiredError}
     * @memberof ShockProfilesApiInterface
     */
    shockProfilesCreateShockProfileRequestOpts(requestParameters: ShockProfilesCreateShockProfileRequest): Promise<runtime.RequestOpts>;

    /**
     * Create a new shock profile.
     * @summary Create a shock profile
     * @param {ShockProfileCreate} shockProfileCreate 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShockProfilesApiInterface
     */
    shockProfilesCreateShockProfileRaw(requestParameters: ShockProfilesCreateShockProfileRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ShockProfile>>;

    /**
     * Create a new shock profile.
     * Create a shock profile
     */
    shockProfilesCreateShockProfile(requestParameters: ShockProfilesCreateShockProfileRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ShockProfile>;

    /**
     * Creates request options for shockProfilesDeleteShockProfile without sending the request
     * @param {string} shockProfileId 
     * @throws {RequiredError}
     * @memberof ShockProfilesApiInterface
     */
    shockProfilesDeleteShockProfileRequestOpts(requestParameters: ShockProfilesDeleteShockProfileRequest): Promise<runtime.RequestOpts>;

    /**
     * Delete the shock profile with the given ID.
     * @summary Delete a shock profile
     * @param {string} shockProfileId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShockProfilesApiInterface
     */
    shockProfilesDeleteShockProfileRaw(requestParameters: ShockProfilesDeleteShockProfileRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Delete the shock profile with the given ID.
     * Delete a shock profile
     */
    shockProfilesDeleteShockProfile(requestParameters: ShockProfilesDeleteShockProfileRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * Creates request options for shockProfilesListShockProfiles without sending the request
     * @param {number} pageSize 
     * @param {number} [page] 
     * @param {SortDirection} [sortDirection] 
     * @param {ShockProfileSortKey} [sortKey] 
     * @throws {RequiredError}
     * @memberof ShockProfilesApiInterface
     */
    shockProfilesListShockProfilesRequestOpts(requestParameters: ShockProfilesListShockProfilesRequest): Promise<runtime.RequestOpts>;

    /**
     * Lists all the shock profiles, optionally filtering by their associated vehicle type.
     * @summary List shock profiles for a given vehicle type.
     * @param {number} pageSize 
     * @param {number} [page] 
     * @param {SortDirection} [sortDirection] 
     * @param {ShockProfileSortKey} [sortKey] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShockProfilesApiInterface
     */
    shockProfilesListShockProfilesRaw(requestParameters: ShockProfilesListShockProfilesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ShockProfile>>>;

    /**
     * Lists all the shock profiles, optionally filtering by their associated vehicle type.
     * List shock profiles for a given vehicle type.
     */
    shockProfilesListShockProfiles(requestParameters: ShockProfilesListShockProfilesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ShockProfile>>;

    /**
     * Creates request options for shockProfilesListShockProfilesMetadata without sending the request
     * @param {number} pageSize 
     * @throws {RequiredError}
     * @memberof ShockProfilesApiInterface
     */
    shockProfilesListShockProfilesMetadataRequestOpts(requestParameters: ShockProfilesListShockProfilesMetadataRequest): Promise<runtime.RequestOpts>;

    /**
     * Fetch information about the total amount of pages available.
     * @summary Shock profile listing metadata for a specific vehicle type.
     * @param {number} pageSize 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShockProfilesApiInterface
     */
    shockProfilesListShockProfilesMetadataRaw(requestParameters: ShockProfilesListShockProfilesMetadataRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PageInfo>>;

    /**
     * Fetch information about the total amount of pages available.
     * Shock profile listing metadata for a specific vehicle type.
     */
    shockProfilesListShockProfilesMetadata(requestParameters: ShockProfilesListShockProfilesMetadataRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PageInfo>;

    /**
     * Creates request options for shockProfilesReadShockProfile without sending the request
     * @param {string} shockProfileId 
     * @throws {RequiredError}
     * @memberof ShockProfilesApiInterface
     */
    shockProfilesReadShockProfileRequestOpts(requestParameters: ShockProfilesReadShockProfileRequest): Promise<runtime.RequestOpts>;

    /**
     * Returns the shock profile specified by the given ID.
     * @summary Get a single shock profile
     * @param {string} shockProfileId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShockProfilesApiInterface
     */
    shockProfilesReadShockProfileRaw(requestParameters: ShockProfilesReadShockProfileRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ShockProfile>>;

    /**
     * Returns the shock profile specified by the given ID.
     * Get a single shock profile
     */
    shockProfilesReadShockProfile(requestParameters: ShockProfilesReadShockProfileRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ShockProfile>;

    /**
     * Creates request options for shockProfilesUpdateShockProfile without sending the request
     * @param {string} shockProfileId 
     * @param {ShockProfileUpdate} shockProfileUpdate 
     * @throws {RequiredError}
     * @memberof ShockProfilesApiInterface
     */
    shockProfilesUpdateShockProfileRequestOpts(requestParameters: ShockProfilesUpdateShockProfileRequest): Promise<runtime.RequestOpts>;

    /**
     * Update a shock profile by a given ID.
     * @summary Update a shock profile.
     * @param {string} shockProfileId 
     * @param {ShockProfileUpdate} shockProfileUpdate 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShockProfilesApiInterface
     */
    shockProfilesUpdateShockProfileRaw(requestParameters: ShockProfilesUpdateShockProfileRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ShockProfile>>;

    /**
     * Update a shock profile by a given ID.
     * Update a shock profile.
     */
    shockProfilesUpdateShockProfile(requestParameters: ShockProfilesUpdateShockProfileRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ShockProfile>;

    /**
     * Creates request options for shockProfilesValidateCreateShockProfile without sending the request
     * @param {ShockProfileCreate} shockProfileCreate 
     * @throws {RequiredError}
     * @memberof ShockProfilesApiInterface
     */
    shockProfilesValidateCreateShockProfileRequestOpts(requestParameters: ShockProfilesValidateCreateShockProfileRequest): Promise<runtime.RequestOpts>;

    /**
     * Validate data for a new shock profile without persisting it. Return an empty body if the data is valid. Return validation errors if it is invalid.
     * @summary Validate a new shock profile
     * @param {ShockProfileCreate} shockProfileCreate 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShockProfilesApiInterface
     */
    shockProfilesValidateCreateShockProfileRaw(requestParameters: ShockProfilesValidateCreateShockProfileRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Validate data for a new shock profile without persisting it. Return an empty body if the data is valid. Return validation errors if it is invalid.
     * Validate a new shock profile
     */
    shockProfilesValidateCreateShockProfile(requestParameters: ShockProfilesValidateCreateShockProfileRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * Creates request options for shockProfilesValidateUpdateShockProfile without sending the request
     * @param {string} shockProfileId 
     * @param {ShockProfileUpdate} shockProfileUpdate 
     * @throws {RequiredError}
     * @memberof ShockProfilesApiInterface
     */
    shockProfilesValidateUpdateShockProfileRequestOpts(requestParameters: ShockProfilesValidateUpdateShockProfileRequest): Promise<runtime.RequestOpts>;

    /**
     * Validate data for updating the given shock profile, without persisting it. Return an empty body if the data is valid. Return validation errors if it is invalid.
     * @summary Validate shock profile update.
     * @param {string} shockProfileId 
     * @param {ShockProfileUpdate} shockProfileUpdate 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShockProfilesApiInterface
     */
    shockProfilesValidateUpdateShockProfileRaw(requestParameters: ShockProfilesValidateUpdateShockProfileRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Validate data for updating the given shock profile, without persisting it. Return an empty body if the data is valid. Return validation errors if it is invalid.
     * Validate shock profile update.
     */
    shockProfilesValidateUpdateShockProfile(requestParameters: ShockProfilesValidateUpdateShockProfileRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

}

/**
 * 
 */
export class ShockProfilesApi extends runtime.BaseAPI implements ShockProfilesApiInterface {

    /**
     * Creates request options for shockProfilesCreateShockProfile without sending the request
     */
    async shockProfilesCreateShockProfileRequestOpts(requestParameters: ShockProfilesCreateShockProfileRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['shockProfileCreate'] == null) {
            throw new runtime.RequiredError(
                'shockProfileCreate',
                'Required parameter "shockProfileCreate" was null or undefined when calling shockProfilesCreateShockProfile().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HttpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/shock_profiles/`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ShockProfileCreateToJSON(requestParameters['shockProfileCreate']),
        };
    }

    /**
     * Create a new shock profile.
     * Create a shock profile
     */
    async shockProfilesCreateShockProfileRaw(requestParameters: ShockProfilesCreateShockProfileRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ShockProfile>> {
        const requestOptions = await this.shockProfilesCreateShockProfileRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ShockProfileFromJSON(jsonValue));
    }

    /**
     * Create a new shock profile.
     * Create a shock profile
     */
    async shockProfilesCreateShockProfile(requestParameters: ShockProfilesCreateShockProfileRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ShockProfile> {
        const response = await this.shockProfilesCreateShockProfileRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for shockProfilesDeleteShockProfile without sending the request
     */
    async shockProfilesDeleteShockProfileRequestOpts(requestParameters: ShockProfilesDeleteShockProfileRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['shockProfileId'] == null) {
            throw new runtime.RequiredError(
                'shockProfileId',
                'Required parameter "shockProfileId" was null or undefined when calling shockProfilesDeleteShockProfile().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HttpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/shock_profiles/{shock_profile_id}`;
        urlPath = urlPath.replace('{shock_profile_id}', encodeURIComponent(String(requestParameters['shockProfileId'])));

        return {
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Delete the shock profile with the given ID.
     * Delete a shock profile
     */
    async shockProfilesDeleteShockProfileRaw(requestParameters: ShockProfilesDeleteShockProfileRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.shockProfilesDeleteShockProfileRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete the shock profile with the given ID.
     * Delete a shock profile
     */
    async shockProfilesDeleteShockProfile(requestParameters: ShockProfilesDeleteShockProfileRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.shockProfilesDeleteShockProfileRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for shockProfilesListShockProfiles without sending the request
     */
    async shockProfilesListShockProfilesRequestOpts(requestParameters: ShockProfilesListShockProfilesRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['pageSize'] == null) {
            throw new runtime.RequiredError(
                'pageSize',
                'Required parameter "pageSize" was null or undefined when calling shockProfilesListShockProfiles().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['page_size'] = requestParameters['pageSize'];
        }

        if (requestParameters['sortDirection'] != null) {
            queryParameters['sort_direction'] = requestParameters['sortDirection'];
        }

        if (requestParameters['sortKey'] != null) {
            queryParameters['sort_key'] = requestParameters['sortKey'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HttpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/shock_profiles/`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Lists all the shock profiles, optionally filtering by their associated vehicle type.
     * List shock profiles for a given vehicle type.
     */
    async shockProfilesListShockProfilesRaw(requestParameters: ShockProfilesListShockProfilesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ShockProfile>>> {
        const requestOptions = await this.shockProfilesListShockProfilesRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ShockProfileFromJSON));
    }

    /**
     * Lists all the shock profiles, optionally filtering by their associated vehicle type.
     * List shock profiles for a given vehicle type.
     */
    async shockProfilesListShockProfiles(requestParameters: ShockProfilesListShockProfilesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ShockProfile>> {
        const response = await this.shockProfilesListShockProfilesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for shockProfilesListShockProfilesMetadata without sending the request
     */
    async shockProfilesListShockProfilesMetadataRequestOpts(requestParameters: ShockProfilesListShockProfilesMetadataRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['pageSize'] == null) {
            throw new runtime.RequiredError(
                'pageSize',
                'Required parameter "pageSize" was null or undefined when calling shockProfilesListShockProfilesMetadata().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['pageSize'] != null) {
            queryParameters['page_size'] = requestParameters['pageSize'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HttpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/shock_profiles/meta`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Fetch information about the total amount of pages available.
     * Shock profile listing metadata for a specific vehicle type.
     */
    async shockProfilesListShockProfilesMetadataRaw(requestParameters: ShockProfilesListShockProfilesMetadataRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PageInfo>> {
        const requestOptions = await this.shockProfilesListShockProfilesMetadataRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PageInfoFromJSON(jsonValue));
    }

    /**
     * Fetch information about the total amount of pages available.
     * Shock profile listing metadata for a specific vehicle type.
     */
    async shockProfilesListShockProfilesMetadata(requestParameters: ShockProfilesListShockProfilesMetadataRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PageInfo> {
        const response = await this.shockProfilesListShockProfilesMetadataRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for shockProfilesReadShockProfile without sending the request
     */
    async shockProfilesReadShockProfileRequestOpts(requestParameters: ShockProfilesReadShockProfileRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['shockProfileId'] == null) {
            throw new runtime.RequiredError(
                'shockProfileId',
                'Required parameter "shockProfileId" was null or undefined when calling shockProfilesReadShockProfile().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HttpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/shock_profiles/{shock_profile_id}`;
        urlPath = urlPath.replace('{shock_profile_id}', encodeURIComponent(String(requestParameters['shockProfileId'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Returns the shock profile specified by the given ID.
     * Get a single shock profile
     */
    async shockProfilesReadShockProfileRaw(requestParameters: ShockProfilesReadShockProfileRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ShockProfile>> {
        const requestOptions = await this.shockProfilesReadShockProfileRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ShockProfileFromJSON(jsonValue));
    }

    /**
     * Returns the shock profile specified by the given ID.
     * Get a single shock profile
     */
    async shockProfilesReadShockProfile(requestParameters: ShockProfilesReadShockProfileRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ShockProfile> {
        const response = await this.shockProfilesReadShockProfileRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for shockProfilesUpdateShockProfile without sending the request
     */
    async shockProfilesUpdateShockProfileRequestOpts(requestParameters: ShockProfilesUpdateShockProfileRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['shockProfileId'] == null) {
            throw new runtime.RequiredError(
                'shockProfileId',
                'Required parameter "shockProfileId" was null or undefined when calling shockProfilesUpdateShockProfile().'
            );
        }

        if (requestParameters['shockProfileUpdate'] == null) {
            throw new runtime.RequiredError(
                'shockProfileUpdate',
                'Required parameter "shockProfileUpdate" was null or undefined when calling shockProfilesUpdateShockProfile().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HttpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/shock_profiles/{shock_profile_id}`;
        urlPath = urlPath.replace('{shock_profile_id}', encodeURIComponent(String(requestParameters['shockProfileId'])));

        return {
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: ShockProfileUpdateToJSON(requestParameters['shockProfileUpdate']),
        };
    }

    /**
     * Update a shock profile by a given ID.
     * Update a shock profile.
     */
    async shockProfilesUpdateShockProfileRaw(requestParameters: ShockProfilesUpdateShockProfileRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ShockProfile>> {
        const requestOptions = await this.shockProfilesUpdateShockProfileRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ShockProfileFromJSON(jsonValue));
    }

    /**
     * Update a shock profile by a given ID.
     * Update a shock profile.
     */
    async shockProfilesUpdateShockProfile(requestParameters: ShockProfilesUpdateShockProfileRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ShockProfile> {
        const response = await this.shockProfilesUpdateShockProfileRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for shockProfilesValidateCreateShockProfile without sending the request
     */
    async shockProfilesValidateCreateShockProfileRequestOpts(requestParameters: ShockProfilesValidateCreateShockProfileRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['shockProfileCreate'] == null) {
            throw new runtime.RequiredError(
                'shockProfileCreate',
                'Required parameter "shockProfileCreate" was null or undefined when calling shockProfilesValidateCreateShockProfile().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HttpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/shock_profiles/validate`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ShockProfileCreateToJSON(requestParameters['shockProfileCreate']),
        };
    }

    /**
     * Validate data for a new shock profile without persisting it. Return an empty body if the data is valid. Return validation errors if it is invalid.
     * Validate a new shock profile
     */
    async shockProfilesValidateCreateShockProfileRaw(requestParameters: ShockProfilesValidateCreateShockProfileRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.shockProfilesValidateCreateShockProfileRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Validate data for a new shock profile without persisting it. Return an empty body if the data is valid. Return validation errors if it is invalid.
     * Validate a new shock profile
     */
    async shockProfilesValidateCreateShockProfile(requestParameters: ShockProfilesValidateCreateShockProfileRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.shockProfilesValidateCreateShockProfileRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for shockProfilesValidateUpdateShockProfile without sending the request
     */
    async shockProfilesValidateUpdateShockProfileRequestOpts(requestParameters: ShockProfilesValidateUpdateShockProfileRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['shockProfileId'] == null) {
            throw new runtime.RequiredError(
                'shockProfileId',
                'Required parameter "shockProfileId" was null or undefined when calling shockProfilesValidateUpdateShockProfile().'
            );
        }

        if (requestParameters['shockProfileUpdate'] == null) {
            throw new runtime.RequiredError(
                'shockProfileUpdate',
                'Required parameter "shockProfileUpdate" was null or undefined when calling shockProfilesValidateUpdateShockProfile().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HttpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/shock_profiles/{shock_profile_id}/validate`;
        urlPath = urlPath.replace('{shock_profile_id}', encodeURIComponent(String(requestParameters['shockProfileId'])));

        return {
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: ShockProfileUpdateToJSON(requestParameters['shockProfileUpdate']),
        };
    }

    /**
     * Validate data for updating the given shock profile, without persisting it. Return an empty body if the data is valid. Return validation errors if it is invalid.
     * Validate shock profile update.
     */
    async shockProfilesValidateUpdateShockProfileRaw(requestParameters: ShockProfilesValidateUpdateShockProfileRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.shockProfilesValidateUpdateShockProfileRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Validate data for updating the given shock profile, without persisting it. Return an empty body if the data is valid. Return validation errors if it is invalid.
     * Validate shock profile update.
     */
    async shockProfilesValidateUpdateShockProfile(requestParameters: ShockProfilesValidateUpdateShockProfileRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.shockProfilesValidateUpdateShockProfileRaw(requestParameters, initOverrides);
    }

}
